/* Importaciones de React */
import React, { useState, useEffect, useCallback } from "react"

/* Importaciones de MUI */
import { Stack, Typography, TextField, InputAdornment, Button } from "@mui/material"
import { Person, Numbers, Phone } from "@mui/icons-material"

/* Importaciones del modulo de Shared */
import { ModalView } from "../../Shared"

export default function CostumerForm({ displayState, addCart, setCreatingQuote }){
    /* Estados */
    const [show, setShow] = displayState
    const [costumerName, setCostumerName] = useState('')
    const [costumerPhone, setCostumerPhone] = useState('')
    const [validForm, setValidForm] = useState(true)

    const clearForm = useCallback(() => {
        setCostumerName('')
        setCostumerPhone('')
    }, [])

    useEffect(() => {
        const isNameValid = costumerName.trim().length >= 3;
        const isPhoneValid = costumerPhone === '' || costumerPhone.length === 10;

        if (isNameValid && isPhoneValid) {
            setValidForm(true)
        } else {
            setValidForm(false)
        }
    }, [costumerName, costumerPhone])

    /* Componente */
    return(
        <ModalView
            displayState={displayState}
            width={'32%'}
            maxHeight={'85%'}
        >
            <Stack
                direction='column'
                spacing={2}
            >
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 700,
                        textAlign: 'center'
                    }}
                >
                    Complete los campos para abrir un nuevo carrito
                </Typography>

                <TextField 
                    label={'Nombre completo del cliente'}
                    placeholder={'Alejandro Gomez Torres'}
                    value={costumerName}
                    onChange={event => setCostumerName(event.target.value.replace(/[^a-zA-Z ]/g, ''))}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><Person color="primary" /></InputAdornment>
                    }}
                    fullWidth
                    focused
                    required
                />

                <TextField 
                    label={'Numero de Telefono'}
                    placeholder={'##########'}
                    value={costumerPhone}
                    onChange={event => setCostumerPhone(event.target.value.replace(/[^0-9]/g, '').slice(0, 10))}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><Phone color="primary" /></InputAdornment>
                    }}
                    fullWidth
                    focused
                />
            </Stack>

            <Stack
                direction='row'
                alignItems='center'
                justifyContent='right'
            >
                <Button 
                    onClick={() => {
                        if(validForm){
                            setCreatingQuote(true)
                            addCart({ name: costumerName, phone: costumerPhone })
                            setCreatingQuote(false)
                            clearForm()
                            setShow(false)
                            return
                        }

                        alert('Ingrese Nombre 3 caracteres o mas y Telefono 10 digitos')
                    }}
                    sx={{ fontSize: '12.4px' }}
                >
                    Agregar cliente y crear carrito
                </Button>

                <Button
                    onClick={() => {
                        clearForm()
                        setShow(false)
                    }}
                    sx={{ fontSize: '12.4px' }}
                >
                    Cerrar
                </Button>
            </Stack>
        </ModalView>
    )
}